import { render, staticRenderFns } from "./CertificatePersonSubsidySchedule.vue?vue&type=template&id=1592f093&scoped=true"
import script from "./CertificatePersonSubsidySchedule.vue?vue&type=script&lang=js"
export * from "./CertificatePersonSubsidySchedule.vue?vue&type=script&lang=js"
import style0 from "./CertificatePersonSubsidySchedule.vue?vue&type=style&index=0&id=1592f093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1592f093",
  null
  
)

export default component.exports